import React, { Component } from 'react';
import { Row, Collapse, Col, Card, CardBody, } from 'reactstrap';
import * as constant from '../../../Corporate/dashboard/constant';
import { goolgeAnalyticsEvents } from '../../../components/GoogleAnalytics/index';
import Maps from '../../../components/Maps/index';
import IndiaMap from '../../../components/Maps/IndiaMap/index';
import { GridLoader } from 'react-spinners';
class DashboardAccordian extends Component {
    constructor(props){
        super();
        this.state={
            Regions:""
        }
    }
    handleAccordianButton = (event) => {
        if(event!=this.state.Regions)this.setState({Regions:event})
        else this.setState({Regions:""})
        goolgeAnalyticsEvents('Corporate', 'Toggle Dashboard Segments Accordians', 'Toggle Accordians', '');
    }
    render() {
        const { data, clickedAside } = this.props;
        let accordion = [], map = null;
        if (data) {
            if (!this.props.switchValue) {
                Object.keys(data).forEach((key, index) => {
                    let accordionData = (<section className="mb-3" key={index}>
                        {(this.props.clickedAside === constant.LEGALCONSTITUTION || (clickedAside !== constant.GEOGRAPHY && key !== 'ALL' && key !== 'ALL_DOMESTIC')) ? <Row noGutters className="accord-header bg-light">
                            <Col sm="8" className="p-3 accord-header__title border-bottom d-flex align-items-center">
                                <span>{key}</span>
                                <div className="d-flex flex-grow-1 pl-1 align-items-center justify-content-between d-sm-none">
                                    <span>Regions</span>
                                    <i data-toggle="collapse" data-target={'#Collapse' + index} className={key === constant.ALL ? "accord-header_mobile-btn-icon accord-header__btn-icon" : "accord-header_mobile-btn-icon accord-header__btn-icon collapsed"}></i>
                                </div>
                            </Col>
                            <Col sm="8" xs="12" className="p-3 text-center accord-header__title border-bottom">
                                {Number(data[key].avgScore).toFixed(0)}&nbsp;<span className="d-block d-sm-none">Average Score</span>
                            </Col>
                            {/*<Col sm="6" xs="12" className="p-3 text-center accord-header__title border-bottom cursor-pointer" onClick={() => this.props.handleApplyFilter(key, '')}>
                                {data[key].numberOfCompanies}&nbsp;<span className="d-block d-sm-none">Companies</span>
                            </Col>*/}
                            <Col sm="6" xs="12" className="p-3 text-center accord-header__title border-bottom cursor-pointer" onClick={() => this.props.handleMapFilter(key, '', '', constant.COMPLETE, '', constant.DOMESTIC)}>
                                {data[key].businessRelations}&nbsp;<span className="d-block d-sm-none">Business Relations</span>
                            </Col>
                            <Col sm="2" data-toggle="collapse" onClick={()=>{this.handleAccordianButton(key)}} data-target={'#Collapse' + index} className={key === this.state.Regions ? "p-3 text-right accord-header__title border-bottom" : "p-3 text-right accord-header__title border-bottom collapsed"}><i className="accord-header__btn-icon"></i></Col>
                        </Row> : ''}
                        <Collapse id={"Collapse" + index} className={key === this.state.Regions ? "show" : ""}>
                            <Card className="accord-body border-0">
                                <CardBody className="p-0">
                                    <Row noGutters>
                                        <Col xs="8" className="p-3 d-flex align-items-center flex-column flex-sm-row border-right border-bottom-danger-4 risk-distribution" onClick={() => this.props.handleMapFilter(key, constant.HIGH, '', constant.COMPLETE, '', constant.DOMESTIC)}>
                                            <h3 className="mr-sm-3 risk-distribution__count">{data[key].riskLevelMap.HIGH}</h3>
                                            <label className="risk-distribution__title text-center text-sm-left">High Risk</label>
                                        </Col>
                                        <Col xs="8" className="p-3 text-center align-items-center flex-column flex-sm-row border-right border-bottom-warning-4 risk-distribution" onClick={() => this.props.handleMapFilter(key, constant.MEDIUM, '', constant.COMPLETE, '', constant.DOMESTIC)}>
                                            <label className="risk-distribution__title text-center text-sm-left">
                                                <span className="mr-sm-3 risk-distribution__count">{data[key].riskLevelMap.MEDIUM}</span>
                                                Moderate Risk</label>
                                        </Col>
                                        <Col xs="6" className="p-3 text-center align-items-center flex-column flex-sm-row border-bottom-success-4 risk-distribution" onClick={() => this.props.handleMapFilter(key, constant.LOW, '', constant.COMPLETE, '', constant.DOMESTIC)}>
                                            <label className="risk-distribution__title text-center text-sm-left">
                                                <span className="mr-sm-3 risk-distribution__count">{data[key].riskLevelMap.LOW}</span>
                                                Low Risk</label>
                                        </Col>
                                        <Col xs="2" className="p-3 d-flex align-items-center flex-column flex-sm-row border-bottom-success-4 risk-distribution" onClick={() => this.props.handleApplyFilter(key, constant.LOW)}>
                                            <label className="risk-distribution__title text-center text-sm-left">
                                                <span className="mr-sm-3 risk-distribution__count"></span>
                                            </label>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Collapse>
                    </section>)
                    if (key === constant.ALL) {
                        accordion.unshift(accordionData)
                    }
                    else {
                        accordion.push(accordionData)
                    }
                }
                )
            }
        }
        return (
            <div className="accord">{(!this.props.switchValue) ? <div>
            <div>{accordion}</div>
            {this.props.clickedAside !== constant.LEGALCONSTITUTION && <IndiaMap data={this.props.caseCountDataByState}
            stateMapPreloader={this.props.stateMapPreloader} 
            corporateId={this.props.corporateId}
            filter={this.props.handleMapFilter}
            />}
            </div>: <Maps data={this.props.mapData} filter={this.props.handleMapFilter} />} </div>
        )
    }
}
export default DashboardAccordian